export default __webpack_public_path__ + "static/media/press_room_img2.7152340e.png";